import React, { Component } from 'react';



import {PersistService} from "../../services/persistService";
import SelectKlassePartiListOption from "../../SelectKlassePartiListOption";




class Login extends Component {

    constructor(props) {
        super(props);
        this.state = {
            proeveId: "",
            passord: "",
            klassePartier: [],
            selectedParti: "",
            showPartiList: false,
            loading: false
        };
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSelectedPartiChange = this.handleSelectedPartiChange.bind(this);
        this.loadPartiKlasser = this.loadPartiKlasser.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.renderPartiListeOgSjekkUt = this.renderPartiListeOgSjekkUt.bind(this);
    }

    loadPartiKlasser(e) {
        e.preventDefault();
        this.setState(() => ({
            loading: true
        }));
        PersistService.getKlassePartier(this.state.proeveId, this.state.passord)
            .then((klassePartier)=>{
                this.setState(() => ({
                    klassePartier,
                    showPartiList: true,
                    loading: false
                }));
            })
            .catch((err)=> {
                alert(err.message);
                this.setState(() => ({
                    showPartiList: false,
                    loading: false
                }))
            });
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });

    }

    handleSelectedPartiChange(event) {
        this.setState({selectedParti: event.target.value});
    }

    onSubmit(e) {
        e.preventDefault();
        this.props.checkOut(this.state.proeveId, this.state.passord, this.state.selectedParti);
    }

    render() {

        var disableHentPartierBtn = false;
        if (this.state.proeveId !== '' && this.state.passord !== '') {
            disableHentPartierBtn = true;
        }
        let partierBtnClass = "btn btn-default has-spinner";
        if (this.state.loading) {
            partierBtnClass += " active";
        }

        return (
            <div>
                <div className="row boxed">
                    <div className="col-sm-12">
                        <div>
                            <br/>
                            <form className="form-horizontal">
                                <div className="form-group">
                                    <label className="col-sm-3 control-label">Prøveid (REFNR)</label>
                                    <div className="col-sm-9">
                                        <input name="proeveId" id="proeveIdInput" className="form-control" autoFocus={true}  placeholder="Refnr"
                                               type="text"
                                               value={this.state.proeveId}
                                               onChange={this.handleInputChange} />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label className="col-sm-3 control-label">Password</label>
                                    <div className="col-sm-9">
                                        <input name="passord" id="passordInput" className="form-control" placeholder="Password"
                                               type="password"
                                               value={this.state.passord}
                                               onChange={this.handleInputChange} />
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label className="col-sm-3 control-label"></label>
                                    <div className="col-sm-9">
                                        <button onClick={this.loadPartiKlasser} className={partierBtnClass} disabled={(!disableHentPartierBtn)}>
                                            <span className="spinner"><i className="fa fa-refresh fa-spin"></i></span>
                                            Hent klasse hold
                                        </button>
                                    </div>
                                </div>
                                {
                                   this.renderPartiListeOgSjekkUt()
                                }
                            </form>


                        </div>
                    </div>
                </div>



            </div>
        );
    }

    renderPartiListeOgSjekkUt() {
        const checkingOut = this.props.checkingOut;
        const klassePartier = this.state.klassePartier;
        var disableCheckOutBtn = false;

        if (this.state.selectedParti !== '') {
            disableCheckOutBtn = true;
        }
        let checkOutBtnClass = "btn btn-default has-spinner";
        if (checkingOut) {
            checkOutBtnClass += " active";
        }
        if (this.state.showPartiList) {
            return (
                <div>
                    <div className="form-group">
                        <label className="col-sm-3 control-label">Vælg klasse hold</label>
                        <div className="col-sm-9">
                            <select className="form-control" onChange={this.handleSelectedPartiChange}>
                                <option value=""></option>
                                {
                                    klassePartier.map(klasseParti => <SelectKlassePartiListOption key={klasseParti.partiId} klasseParti={klasseParti} showDeltPaaOevelseInfo={true} />)
                                }
                            </select>
                        </div>
                    </div>


                    <div className="form-group">
                        <div className="col-sm-offset-3 col-sm-9">
                            <button className={checkOutBtnClass} onClick={this.onSubmit} disabled={(!disableCheckOutBtn)}>
                                <span className="spinner"><i className="fa fa-refresh fa-spin"></i></span>
                                Hent kritikker
                            </button>
                        </div>
                    </div>


                </div>
            );
        }
        return null;

    }


}
export default Login;





// WEBPACK FOOTER //
// ./src/pages/sync/Login.js